// DS: C16A, C16B
/** A collapsable, lazy loaded editor specifically configured for comment posting */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import AnonymousView from './views/AnonymousView';
import CantPostView from './views/CantPostView';
import EditorView from './views/EditorView';
import CommentBoxSkeleton from '../CommentBoxSkeleton';
/** Our classic CommentBox implementation. */ const CommentBox = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { autoFocus, onPost, onClose, footerClassName, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, nc, editorView, onEditorReady } = _param, rest = _object_without_properties(_param, [
        "autoFocus",
        "onPost",
        "onClose",
        "footerClassName",
        'aria-label',
        'aria-labelledby',
        "nc",
        "editorView",
        "onEditorReady"
    ]);
    return /*#__PURE__*/ React.createElement(CommentBoxSkeleton, _object_spread({
        loggedOutView: /*#__PURE__*/ React.createElement(AnonymousView, null),
        editorView: editorView || /*#__PURE__*/ React.createElement(EditorView, {
            nc: nc,
            onPost: onPost,
            onCancel: onClose,
            footerClassName: footerClassName,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            onEditorReady: onEditorReady
        }),
        cantPostView: /*#__PURE__*/ React.createElement(CantPostView, null),
        autoFocus: autoFocus,
        onEditorReady: onEditorReady,
        ref: ref
    }, rest));
});
CommentBox.displayName = 'CommentBox';
export default CommentBox;

//# sourceMappingURL=CommentBox.js.map